import ReactGA from "react-ga4"; // Google Analytics

  // Google Analytics
  export const initGA = () => {
    ReactGA.initialize("G-7D4B97M9J1"); // Coloque seu ID de medição aqui
  };
  
  // Google Analytics
  export const logPageView = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  };